import _ from 'lodash';
import * as React from 'react';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
// import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import useFetch from 'use-http';
import { Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { useForm } from 'react-hook-form';
import Select, { StylesConfig } from 'react-select';
import TsdiClient from 'src/models/AP/Client';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import { ODataOptions, ODataFilter, ODataFilterOperators } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import Landman from 'src/models/Landman';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import Invoice from 'src/components/project-billing/models/InvoiceMaster';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import TsdiAltSubcode from 'src/models/AP/AltSubcode';
import TsdiSubcode from 'src/models/AP/Subcode';
import TsdiInvoiceGroup from 'src/components/project-billing/models/InvoiceGroup';
import Fieldset from 'src/components/project-billing/components/FieldSetComponent';
import CreatableSelect from 'react-select/creatable';

interface IClientProjectSearchProps {
    totalClients?: number;
    parentComponent?: string;
    selectedPayperiod?: string;
    setIsCollapsed?: (isCollpased: boolean) => void;
    clearSearchFilters?: (caller: string) => void;
    setSelectedClient?: (clientNumber: TsdiClient) => void;
    setSelectedFormatType?: (formatType: string) => void;
    setPayPeriodSearchTerm?: (payPeriodSearchTerm: string) => void;
    setInvoiceSearchTerm?: (invoiceSearchTerm: string) => void;
    setSelectedSource?: (source: string) => void;
    setSelectedProject?: (project: ProspectDetails) => void;
    setSelectedSubcode?: (subcode: TsdiSubcode) => void;
    setSelectedGroupNumber?: (groupNumber: number) => void;
    setSelectedCreatedByNumber?: (createdByNumber: number) => void;
    setSelectedTotal?: (createdByNumber: number) => void;
    setSelectedAltSubcode?: (altSubcode: TsdiAltSubcode) => void;
    setSelectedManager?: (managerNumber: string) => void;
    setSelectedPayPeriod?: (payPeriod: string) => void;
    setSelectedBeginDate?: (beginDate: Date) => void;
    setSelectedEndDate?: (endDate: Date) => void;
    setSelectedInvoiceDate?: (invoiceDate: Date) => void;
    setSelectedOffice?: (office: string) => void;
    unpostedInvoiceOption?: boolean;
    setExcludePosted?: (excludePosted: boolean) => void;
    setTotalLike?: (like: boolean) => void;
    setExcludeUnPosted?: (excludePosted: boolean) => void;
    setExcludeVoid?: (excludeVoid: boolean) => void;
    setExcludeNonVoid?: (excludeNonVoid: boolean) => void;
    setSortDirection?: (direction: boolean) => void;
    setVoidOnly?: (voidOnly: boolean) => void;
    selectedClient?: TsdiClient;
    selectedProject?: number;
    clients?: Array<TsdiClient>;
    offices?: Array<string>;
    projects?: boolean;
    subcodes?: boolean;
    altSubcodes?: boolean;
    payPeriods?: Array<{id: number | string, name: string}>;
    managers?: Landman[];
    invoices?: Array<Invoice>;
    invoiceGroups?: Array<TsdiInvoiceGroup>;
    runQuery?: () => void;
    size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14;
}

interface IOptionType {
    value: string;
    label: string;
  }

const ClientProjectSearch = (props: IClientProjectSearchProps) => {
    const { get, response } = useFetch();
    const { reset, register, errors, setValue, control, getValues } = useForm();
    const [groupNumberInputValue, setGroupNumberInputValue] = useState('');
    const [totalInputValue, setTotalInputValue] = useState('');
    const [clientSearchTerm, setClientSearchTerm] = useState<string>(undefined);
    const [invoiceSearchTerm, setInvoiceSearchTerm] = useState<string>(undefined);
    const [fetchNextClientPage, setFetchNextClientPage] = useState<boolean>(true);
    const [fetchNextInvoicePage, setFetchNextInvoicePage] = useState<boolean>(true);
    const [clientResultsPlaceholder, setClientResultsPlaceholder] = useState<string>('Select Client'); // Used to inform user about personnel list results
    const [projectResultsPlaceholder, setProjectResultsPlaceholder] = useState<string>('Select Project'); // Used to inform user about personnel list results
    const [subcodeSearchResultsPlaceholder, setSubcodeSearchResultsPlaceholder] = useState<string>('Select Subcode'); // Used to inform user about personnel list results
    const [altSubcodeSearchResultsPlaceholder, setAltSubcodeSearchResultsPlaceholder] = useState<string>('Select Alt Subcode'); // Used to inform user about personnel list results
    const [payPeriodResultsPlaceholder, setPayPeriodResultsPlaceholder] = useState<string>('Select Pay Period'); // Used to inform user about personnel list results
    const [invoiceResultsPlaceholder, setInvoiceResultsPlaceholder] = useState<string>('Select Invoice #'); // Used to inform user about personnel list results
    const [officeResultsPlaceholder, setOfficeResultsPlaceholder] = useState<string>('Select Office'); // Used to inform user about personnel list results
    const [sourceResultsPlaceholder, setSourceResultsPlaceholder] = useState<string>('Select Source'); // Used to inform user about personnel list results
    const [formatsPlaceholder, setFormatsPlaceholder] = useState<string>('Select Office'); // Used to inform user about personnel list results
    const [invoiceGroupPlaceholder, setInvoiceGroupPlaceholder] = useState<string>('Select Group'); // Used to inform user about personnel list results
    const [createdByPlaceholder, setCreatedByPlaceholder] = useState<string>('Created By'); // Used to inform user about personnel list results
    const [totalPlaceholder, setTotalPlaceholder] = useState<string>('Created By'); // Used to inform user about personnel list results
    const [managerResultsPlaceholder, setManagerResultsPlaceholder] = useState<string>('Select Manager'); // Used to inform user about personnel list results
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false); // Used to collapse the Search Personnel Panel to make room for other components
    const [isLoading, setIsLoading] = useState<boolean>(true); // isLoading is true if fetching personnel still
    const [isUserSearchingClients, setIsUserSearchingClients] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingSubcodes, setIsUserSearchingSubcodes] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingProjects, setIsUserSearchingProjects] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingAltSubcodes, setIsUserSearchingAltSubcodes] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingManagers, setIsUserSearchingManagers] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingPayPeriods, setIsUserSearchingPayPeriods] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingInvoices, setIsUserSearchingInvoices] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingOffices, setIsUserSearchingOffices] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingSources, setIsUserSearchingSources] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingFormats, setIsUserSearchingFormats] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingCreatedBy, setIsUserSearchingCreatedBy] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingTotal, setIsUserSearchingTotal] = useState<boolean>(false); // true if the search text is not empty
    const [isUserSearchingGroupNumber, setIsUserSearchingGroupNumber] = useState<boolean>(false); // true if the search text is not empty
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [clientSearchDataOptions, setClientSearchDataOptions] = useState<ODataOptions>(undefined);
    const [invoiceSearchDataOptions, setInvoiceSearchDataOptions] = useState<ODataOptions>(undefined);
    const [projects, setProjects] = useState<Array<ProspectDetails>>(undefined);
    const [subcodes, setSubcodes] = useState<Array<TsdiSubcode>>(undefined);
    const [altSubcodes, setAltSubcodes] = useState<Array<TsdiAltSubcode>>(undefined);
    const [managers, setManagers] = useState<Array<Landman>>(undefined);
    const [selectedPayPeriodOption, setSelectedPayPeriodOption] = useState<{ value: string, label: string}>(undefined);
    const [payPeriods, setPayPeriods] = useState<Array<{id: number | string, name: string}>>(undefined);
    const [invoices, setInvoices] = useState<Array<{id: number | string, name: string}>>(undefined);
    const [selectedClient, setSelectedClient] = useState<number>(undefined);
    const [createdByList, setCreatedByList] = useState<Array<{ value: string, label: string}>>(undefined);
    // const [unpostedInvoiceOption, setUnpostedInvoiceOption] = useState<boolean>(false);
    // const [voidInvoiceOption, setVoidInvoiceOption] = useState<boolean>(false);
    // const [nonVoidInvoiceOption, setNonVoidInvoiceOption] = useState<boolean>(false);
    const [selectedProject, setSelectedProject] = useState<number>(undefined);
    const [selectedSubcode, setSelectedSubcode] = useState<number>(undefined);
    const [selectedOffice, setSelectedOffice] = useState<string>(undefined);
    const [selectedGroupNumber, setSelectedGroupNumber] = useState<number>(undefined);
    const [selectedCreatedByNumber, setSelectedCreatedByNumber] = useState<number>(undefined);
    const [selectedTotal, setSelectedTotal] = useState<number>(undefined);
    const [selectedFormatType, setSelectedFormatType] = useState<string>(undefined);
    const [selectedAltSubcode, setSelectedAltSubcode] = useState<number>(undefined);
    const [selectedPayPeriod, setSelectedPayPeriod] = useState<string>(undefined);
    const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState<number>(undefined);
    const [selectedBeginDate, setSelectedBeginDate] = useState<Date>(undefined);
    const [selectedEndDate, setSelectedEndDate] = useState<Date>(undefined);
    const [selectedInvoiceDate, setSelectedInvoiceDate] = useState<Date>(undefined);
    const [clientSearchResults, setClientSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The clients filtered by search (Name)
    const [projectSearchResults, setProjectSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The projects filtered by search (Name)
    const [subcodeSearchResults, setSubcodeSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The subcodes filtered by search (Name)
    const [altSubcodeSearchResults, setAltSubcodeSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The altSubcodes filtered by search (Name)
    const [managerSearchResults, setManagerSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The clients filtered by search (Name)
    const [payPeriodSearchResults, setPayPeriodSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The pay periods filtered by search (number)
    const [invoiceSearchResults, setInvoiceSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The invoices filtered by search (Name)
    const [officeSearchResults, setOfficeSearchResults] = useState<Array<{ value: string; label: string }>>(undefined); // The clients filtered by search (Name)
    const [formatTypes, setFormatTypes] = useState<Array<{ value: string; label: string }>>(undefined); // The clients filtered by search (Name)

    const customStyles: StylesConfig<IOptionType, false> = {
        placeholder: (provided) => ({
            ...provided,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }),
        control: (provided) => ({
          ...provided,
          minHeight: '30px',    // Set a smaller minHeight
          height: '30px',       // Force a smaller height
          padding: '0px',       // Remove internal padding to make it smaller
        }),
        valueContainer: (provided) => ({
          ...provided,
          padding: '0px 8px',   // Adjust padding to make the height smaller
          height: '30px',       // Force height for the container
        }),
        input: (provided) => ({
          ...provided,
          margin: '0px',        // Ensure no margins are added
          padding: '0px',       // Ensure no padding is added
          whiteSpace: 'nowrap'  // Ensure that the content doesn't wrap
        }),
        indicatorsContainer: (provided) => ({
          ...provided,
          height: '30px',       // Force the height of the dropdown indicators
        }),
        dropdownIndicator: (provided) => ({
          ...provided,
          padding: '0px',       // Remove extra padding from the dropdown arrow
        }),
        clearIndicator: (provided) => ({
          ...provided,
          padding: '0px',       // Remove extra padding from the clear indicator
        }),
      };

    useEffect(() => {
        reset({ createdByNumber: null, clientSearchResults: null });
        initializeClientSearchOptions();
        initializeInvoiceSearchOptions();
        setFormatTypes([
            { value: 'A', label: 'A' },
            { value: 'B', label: 'B' },
            { value: 'C', label: 'C' },
            { value: 'D', label: 'D' },
            { value: 'E', label: 'E' },
            { value: 'F', label: 'F' },
            { value: 'G', label: 'G' },
            { value: 'H', label: 'H' },
            { value: 'I', label: 'I' },
            { value: 'J', label: 'J' },
            { value: 'K', label: 'K' },
            { value: 'L', label: 'L' },
            { value: 'M', label: 'M' },
            { value: 'R', label: 'R' },
        ]);
        setInvoiceGroupPlaceholder(`Group #`);
        setCreatedByPlaceholder(`Created By #`);
        setTotalPlaceholder(`Total`);
        setSourceResultsPlaceholder('Source');
        getCreatedByList('');
    }, []);

    useEffect(() => {
        if (Array.isArray(clients) && clients.length > 0) {
            if (!isNaN(props?.selectedClient?.clientNumber)) {
                setSelectedClient(props?.selectedClient?.clientNumber);
            }
        }
    }, [clients]);

    useEffect(() => {
        if (Array.isArray(createdByList) && createdByList.length > 0) {
            console.log(createdByList);
        }
    }, [createdByList]);

    useEffect(() => {
        if (selectedBeginDate && props?.setSelectedBeginDate) {
            props.setSelectedBeginDate(selectedBeginDate);
        }
    }, [selectedBeginDate]);

    useEffect(() => {
        if (selectedEndDate && props?.setSelectedEndDate) {
            props.setSelectedEndDate(selectedEndDate);
        }
    }, [selectedEndDate]);

/*     useEffect(() => {
        if (nonVoidInvoiceOption !== null && typeof props?.setExcludeVoid === 'function') {
            props?.setExcludeVoid(nonVoidInvoiceOption);
        }
    }, [nonVoidInvoiceOption]); */

    useEffect(() => {
        if (props?.selectedClient && !isLoading) {
            if (!isNaN(Number(props?.selectedClient?.clientNumber))) {
                setClientSearchTerm(props?.selectedClient?.clientNumber.toString());
                setValue('clientSearchResults', props?.selectedClient.clientNumber.toString());
                setSelectedClient(props?.selectedClient?.clientNumber);
            }
        }
    }, [props?.selectedClient]);

    useEffect(() => {
        if (!isNaN(Number(props?.selectedProject)) && !isLoading) {
            setSelectedProject(props?.selectedProject);
            setValue('projectSearchResults', props?.selectedProject?.toString());
        }
    }, [props?.selectedProject]);

    useEffect(() => {
        if (selectedInvoiceDate) {
            props.setSelectedInvoiceDate(selectedInvoiceDate);
        }
    }, [selectedInvoiceDate]);

    useEffect(() => {
        if (!!selectedGroupNumber) {
            if (typeof props?.setSelectedGroupNumber === 'function') {
                props?.setSelectedGroupNumber(selectedGroupNumber);
            }
        }
    }, [selectedGroupNumber]);

    useEffect(() => {
        if (!!selectedTotal) {
            if (typeof props?.setSelectedCreatedByNumber === 'function') {
                props?.setSelectedTotal(selectedTotal);
            }
        }
    }, [selectedTotal]);

    useEffect(() => {
        if (!!selectedCreatedByNumber) {
            if (typeof props?.setSelectedCreatedByNumber === 'function') {
                props?.setSelectedCreatedByNumber(selectedCreatedByNumber);
            }
        }
    }, [selectedCreatedByNumber]);

    useEffect(() => {
        if (formatTypes && Array.isArray(formatTypes)) {
            setFormatsPlaceholder(`Format (${formatTypes?.length})`);
        }
    }, [formatTypes]);

    useEffect(() => {
        if (clientSearchDataOptions) {
            // Todo: setSelectedClient to debounced client number
            getClients();
        }
    }, [clientSearchDataOptions]);

    const incrementClients = () => {
        if (!!fetchNextClientPage) {
            let newSearchOptions = _.cloneDeep(clientSearchDataOptions);
            newSearchOptions.incrementPageNumber();
            setClientSearchDataOptions(newSearchOptions);
        }
    };

    const incrementInvoices = () => {
        if (!!fetchNextInvoicePage) {
            let newSearchOptions = _.cloneDeep(invoiceSearchDataOptions);
            newSearchOptions.incrementPageNumber();
            setInvoiceSearchDataOptions(newSearchOptions);
        }
    };

    useEffect(() => {
        if (!!props?.selectedPayperiod && !isNaN(Number(props?.selectedPayperiod))) {
            setSelectedPayPeriod(props?.selectedPayperiod);
        }
    }, [props?.selectedPayperiod]);

    useEffect(() => {
        if (props.setIsCollapsed) {
            props.setIsCollapsed(isCollapsed);
        }
    }, [isCollapsed]);

    useEffect(() => {
        if (!!props?.managers) {
            setManagers(props.managers);
        }
    }, [props.managers]);

    useEffect(() => {
        if (!!props?.payPeriods) {
            setPayPeriods(props.payPeriods);
        }
    }, [props.payPeriods]);

    useEffect(() => {
        if (!!props?.invoices) {
            setInvoices(props?.invoices.map((i, index) => {
                 return { id: index, name: i.number };
         } ));
        }
    }, [props.invoices]);

    // SelectedClient will change when the user clicks on a user or on initial render, if url contains an id
    useEffect(() => {
        if (selectedClient) {
            const clientIndex = Array.isArray(clients) ? clients.findIndex((c) => c.clientNumber === selectedClient) : -1;
            if (clientIndex !== -1) {
                props.setSelectedClient(clients[clientIndex]);
                localStorage.setItem('backOfficeSelectedClientNumber', clients[clientIndex].clientNumber.toString());
                localStorage.setItem('backOfficeSelectedClientName', clients[clientIndex].clientName);
                if (props?.projects) {
                    setProjectSearchResults(undefined);
                    getProjects();
                }
            } else {
                setSelectedClient(undefined);
            }
        }
    }, [selectedClient]);

    // SelectedProject will change when the user clicks on a user or on initial render, if url contains an id
    useEffect(() => {
        if (selectedProject && Array.isArray(projects) && projects.length > 0) {
            const project = projects.find((p) => p.number === selectedProject);

            if (project?.name) {
                localStorage.setItem('backOfficeSelectedProjectName', project?.name);
            }
            if (!isNaN(project?.number) && project?.number !== 0) {
                localStorage.setItem('backOfficeSelectedProjectNumber', project.number.toString());
            }
            if (project) {
                props.setSelectedProject(project);
            }
            getSubcodes();
        }
    }, [selectedProject]);

    // SelectedSubcode will change when the user clicks on a user or on initial render, if url contains an id
    useEffect(() => {
        if (selectedSubcode) {
            const subcode = subcodes.find((s) => s.number === selectedSubcode);
            if (subcode) {
                const subcodeId = subcode?.id;
                const subcodeName = subcode?.name;
                localStorage.setItem('backOfficeSelectedSubcodeNumber', selectedSubcode.toString());
                if (!!subcodeName) {
                    localStorage.setItem('backOfficeSelectedSubcodeName', subcodeName);
                }
                props.setSelectedSubcode(subcode);
                if (subcodeId) {
                    getAltSubCodes(subcodeId);
                }
            }
        }
    }, [selectedSubcode]);

    useEffect(() => {
        if (selectedOffice) {
            localStorage.setItem('backOfficeSelectedOffice', selectedOffice);
        } else {
            localStorage.removeItem('backOfficeSelectedOffice');
        }
    }, [selectedOffice]);

    useEffect(() => {
        if (selectedFormatType) {
            props.setSelectedFormatType(selectedFormatType);
        }
    }, [selectedFormatType]);

    // SelectedAltSubcode will change when the user clicks on a user or on initial render, if url contains an id
    useEffect(() => {
        if (selectedAltSubcode) {
            const altSubcodeName = altSubcodes.find((as) => as.number === selectedAltSubcode).name;
            localStorage.setItem('backOfficeSelectedAltSubcodeNumber', selectedAltSubcode.toString());
            if (!!altSubcodeName) {
                localStorage.setItem('backOfficeSelectedAltSubcodeName', altSubcodeName);
            }
            const altSubcode = altSubcodes.find((as) => as.number === selectedAltSubcode);
            props.setSelectedAltSubcode(altSubcode);
        }
    }, [selectedAltSubcode]);

    useEffect(() => {
        if (props?.setSelectedPayPeriod) {
            props.setSelectedPayPeriod(selectedPayPeriod);
        }
    }, [selectedPayPeriod]);

    // clientSearchResults is updated when the user clicks, focuses, or types in the Search Bar
    useEffect(() => {
        if (clientSearchResults?.length) {
            setIsLoading(false);

            if (props?.selectedClient &&
                clientSearchResults?.length === 1 &&
                Number(clientSearchResults[0].value) === props?.selectedClient?.clientNumber) {
                const currentValues = getValues();
                if (!currentValues.clientSearchResults) {
                    setValue('clientSearchResults', props?.selectedClient?.clientNumber.toString(), {
                        shouldDirty: true
                    });
                    handleClientListSelectChanged(props?.selectedClient?.clientNumber.toString());
                }
            } else if (!props?.selectedClient) {
                setClientResultsPlaceholder(`Select Client (${!isNaN(props?.totalClients) ? props?.totalClients : (clientSearchResults?.length !== undefined ? clientSearchResults.length : 0)})`);
            }
        }
    }, [clientSearchResults]);

    // projectSearchResults is updated when the user clicks, focuses, or types in the Search Bar
    useEffect(() => {
        if (projectSearchResults?.length) {
            setIsLoading(false);
            if (selectedProject && Array.isArray(projectSearchResults) &&
                projectSearchResults.length > 0) {
                const project = projectSearchResults.find((p) => p.value === selectedProject.toString());
                if (project) {
                    const currentValues = getValues();
                    if (!currentValues.projectSearchResults) {
                        setValue('projectSearchResults', selectedProject.toString(), {
                            shouldDirty: true
                        });
                    }
                    getSubcodes();
                }
            } else if (selectedProject) {
                setProjectResultsPlaceholder(`Select Project (${projectSearchResults?.length !== undefined ? projectSearchResults.length : 0})`);
            }
        }
    }, [projectSearchResults]);

    // subcodeSearchResults is updated when the user clicks, focuses, or types in the Search Bar
    useEffect(() => {
        if (subcodeSearchResults?.length) {
            setIsLoading(false);
            let storedSubcode = '';
            if (!selectedSubcode) {
                storedSubcode = localStorage.getItem('backOfficeSelectedSubcodeNumber');
                const numericSubcode = Number(storedSubcode);
                if (!isNaN(numericSubcode)) {
                    setSelectedSubcode(numericSubcode);
                }
            } else if (selectedSubcode && Array.isArray(subcodeSearchResults) &&
                subcodeSearchResults.length > 0) {
                const subcode = subcodeSearchResults.find((p) => p.value === selectedSubcode.toString());
                if (subcode) {
                    const currentValues = getValues();
                    if (!currentValues.subcodeSearchResults) {
                        setValue('subcodeSearchResults', selectedSubcode.toString(), {
                            shouldDirty: true
                        });
                    }
                }
            } else if (selectedSubcode) {
                setSubcodeSearchResultsPlaceholder(`Select Subcode (${subcodeSearchResults?.length !== undefined ? subcodeSearchResults.length : 0})`);
            }
        }
    }, [subcodeSearchResults]);

    // altSubcodeSearchResults is updated when the user clicks, focuses, or types in the Search Bar
    useEffect(() => {
        if (altSubcodeSearchResults?.length) {
            setIsLoading(false);
            let storedAltSubcode = '';
            if (!selectedAltSubcode) {
                storedAltSubcode = localStorage.getItem('backOfficeSelectedAltSubcodeNumber');
                const numericAltSubcode = Number(storedAltSubcode);
                if (!isNaN(numericAltSubcode)) {
                    setSelectedAltSubcode(numericAltSubcode);
                }
            } else if (selectedAltSubcode && Array.isArray(altSubcodeSearchResults) &&
                altSubcodeSearchResults.length > 0) {
                const altSubcode = altSubcodeSearchResults.find((p) => p.value === selectedAltSubcode.toString());
                if (altSubcode) {
                    const currentValues = getValues();
                    if (!currentValues.altSubcodeSearchResults) {
                        setValue('altSubcodeSearchResults', selectedAltSubcode.toString(), {
                            shouldDirty: true
                        });
                    }
                }
            } else if (selectedAltSubcode) {
                setAltSubcodeSearchResultsPlaceholder(`Select Alt Subcode (${altSubcodeSearchResults?.length !== undefined ? altSubcodeSearchResults.length : 0})`);
            }
        }
    }, [altSubcodeSearchResults]);

    useEffect(() => {
        if (managerSearchResults?.length) {
            setIsLoading(false);
        }

        setManagerResultsPlaceholder(`Select Manager (${managerSearchResults?.length})`);
    }, [managerSearchResults]);

    useEffect(() => {
        if (payPeriodSearchResults?.length) {
            setIsLoading(false);
        }

        setPayPeriodResultsPlaceholder(`Select Pay Period (${payPeriodSearchResults?.length})`);
        if (props?.selectedPayperiod && Array.isArray(payPeriodSearchResults)) {
            const payPeriodOption = payPeriodSearchResults.find(pp => pp.label.replace('-', '').replace('(', '').replace(')', '') === props?.selectedPayperiod);
            setSelectedPayPeriodOption(payPeriodOption);
            // setValue('payPeriodsearchResults', payPeriodOption?.value);
        }
    }, [payPeriodSearchResults]);

    useEffect(() => {
        if (invoiceSearchResults?.length) {
            setIsLoading(false);
        }

        setInvoiceResultsPlaceholder(`Select Invoice # (${selectedInvoiceNumber ?
            selectedInvoiceNumber : (invoiceSearchResults?.length ? invoiceSearchResults.length : 0)})`);
    }, [invoiceSearchResults]);

    useEffect(() => {
        if (officeSearchResults?.length) {
            setIsLoading(false);
        }

        setOfficeResultsPlaceholder(`Select Office (${officeSearchResults?.length})`);
    }, [officeSearchResults]);

    // clientList should only change once, on initial render (it contains the full list of clients)
    useEffect(() => {
        if (clients?.length) {

            let list = clients?.map((c) => {
                return { 
                    label: (c.clientName ? `(${c.clientName})(${c.clientNumber})` : ''), 
                    value: `${c.clientNumber}` };
            });
            setClientSearchResults(list);
        }
    }, [clients]);

    // projectList should only change once, on initial render (it contains the full list of projects)
    useEffect(() => {
        if (projects?.length) {

            let list = projects?.map(p => {
                return { 
                    label: (p.name ? `(${p.name})(${p.number})` : ''),
                    value: `${p.number}` };
            });
            setProjectSearchResults(list);
        }
    }, [projects]);

    // subcodeList should only change once, on initial render (it contains the full list of subcodes)
    useEffect(() => {
        if (subcodes?.length) {
            let list = subcodes?.map(s => {
                return {
                    label: (s.survey ? `(${s.survey}) ` : (s?.township && s?.range ? s.township + ' ' + s.range : '')),
                    value: `${s.number}` };
            });
            setSubcodeSearchResults(list);
        }
    }, [subcodes]);

    useEffect(() => {
        if (altSubcodes?.length) {
            let list = altSubcodes?.map(as => {
                return {
                    label: (as.name ? `(${as.name}) ` : ''),
                    value: `${as.number}` };
            });
            setAltSubcodeSearchResults(list);
        }
    }, [altSubcodes]);

    useEffect(() => {
        if (managers?.length) {

            let list = managers?.map(m => {
                return { 
                    label: (!!m.lastName && !!m.firstName ? `(${m.firstName + ' ' + m.lastName})` : ''), 
                    value: `${m.lmsNumber}` };
            });
            setManagerSearchResults(list);
        }
    }, [managers]);

    useEffect(() => {
        if (payPeriods?.length) {

            let list = payPeriods?.map(p => {
                return { 
                    label: (!!p.name ? `(${p.name})` : ''), 
                    value: `${p.id}` };
            });
            setPayPeriodSearchResults(list);
        }
    }, [payPeriods]);

    useEffect(() => {
        if (invoices?.length) {

            const list = invoices?.map(p => {
                return {
                    label: (!!p.name ? `(${p.name})` : ''),
                    value: `${p.id}` };
            });
            setInvoiceSearchResults(list);
        }
    }, [invoices]);

    useEffect(() => {
        if (props?.offices?.length) {

            const list = props?.offices?.map((o, index) => {
                return {
                    label: (!!o ? `(${o})` : ''),
                    value: `${index + 1}` };
            });
            setOfficeSearchResults(list);
        }
    }, [props?.offices]);

    const initializeClientSearchOptions = () => {
        const tableConfig: ITableConfig = {
            rowCount: 250,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        const options = ODataOptions.from(tableConfig);
        setClientSearchDataOptions(options);
    };

    const initializeInvoiceSearchOptions = () => {
        const tableConfig: ITableConfig = {
            rowCount: 250,
            idField: 'im.INVOICE_NO',
            pageNumber: 1,
            columns: []
        };
        const options = ODataOptions.from(tableConfig);
        setInvoiceSearchDataOptions(options);
    };

    const getCreatedByList = async (createdBy: string) => {
        let result = await get(`/v1.0/AccountsReceivable/invoices/createdby${createdBy ? '/' + createdBy : ''}`);

        if (response.ok && result?.length > 0) {
            const createdByOptions = result.map((i: { tsdiNumber: number, name: string }) => ({
                value: i.tsdiNumber.toString(),
                label: `${i.name} (${i.tsdiNumber})`
            }));
            setCreatedByList(createdByOptions);
        } else {
            setCreatedByList([]);
            console.log('Unable to get CreatedBy List Data!!!');
        }
    };

/*     const getSubCodeId = () => {
        const subcodId = subcodes.find(sc => sc.number === selectedAltSubcode)?.id;
        return subcodId;
    }; */

    const getClients = async () => {
        let result = await get(`/v1.0/AccountsPayable/clients${clientSearchDataOptions.toString()}`);

        if (response.ok) {
            if (clientSearchDataOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(clients);
                tempResult = [...tempResult].concat([...result.items]);
                setClients([]);
                setClients(tempResult);
            } else {
                setClients(result.items);
            }
            setFetchNextClientPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get client data!!!');
        }
    };

    const getAltSubCodes = async (subCodeId: number) => {
        if (subCodeId) {
            let result = await get(`/v1.0/ClientProjectMaintenance/subcode/${subCodeId}/altsubcodes`);

            if (response.ok) {
                setAltSubcodes([]);
                setAltSubcodes(result);
            } else {
                setAltSubcodes([]);
                console.log('Unable to get alt subcode data!');
            }
        }
    };

    const getSubcodes = async () => {
        if (clients === undefined || clients?.length < 1) {
            return;
        }
        if (projects === undefined || projects?.length < 1) {
            return;
        }
        const projectId = projects[projectNumberToIndex(selectedProject)]?.id;
        const clientNumber = clients?.find((c) => c?.clientNumber === selectedClient)?.clientNumber;
        if (!clientNumber || !projectId) {
            return;
        }
        let result = await get(`/v1.0/ClientProjectMaintenance/client/${clientNumber}/project/${projectId}/subcodes`);

        if (response.ok) {
            setSubcodes([]);
            setSubcodes(result);
        } else {
            setSubcodes([]);
            console.log('Unable to get subcode data!');
        }
    };

    const getProjects = async () => {
        if (clients === undefined || clients?.length < 1) {
            return;
        }
        const clientIndex = clients?.findIndex((c) => c?.clientNumber === selectedClient);
        if (clientIndex === -1) {
            return;
        }
        let result = await get(`/v1.0/ClientProjectMaintenance/projects/byclient/${clients[clientIndex].clientNumber}`);

        if (response.ok) {
            setProjects([]);
            setProjects(result);
        } else {
            setProjects([]);
            console.log('Unable to get client data!');
        }
    };

    const search = _.debounce((inputText: string) => {
        if (!!inputText && inputText.length > 0) {
            setClientSearchTerm(inputText);
        }
    }, 800);

    const payPeriodSearch = _.debounce((inputText: string) => {
        if (!!inputText && inputText.length > 0 && props?.setPayPeriodSearchTerm) {
            props.setPayPeriodSearchTerm(inputText);
        }
    }, 800);

    const invoiceSearch = _.debounce((inputText: string) => {
        if (!!inputText && inputText.length > 0 && props?.setInvoiceSearchTerm) {
            props.setInvoiceSearchTerm(inputText);
        }
    }, 700);

    const invoiceGroupSearch = _.debounce((inputText: string) => {
        if (!!inputText && inputText.length > 0) {
            setSelectedGroupNumber(Number(inputText));
        }
    }, 600);

    const createdBySearch = _.debounce((inputText: string) => {
        if (!!inputText && inputText.length > 0) {
            setSelectedCreatedByNumber(Number(inputText));
        }
    }, 500);

    const totalSearch = _.debounce((inputText: string) => {
        if (!!inputText && inputText.length > 0) {
            setSelectedTotal(Number(inputText));
        }
    }, 500);

    useEffect(() => {
        if (!!clientSearchTerm || clientSearchTerm === '') {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (!!invoiceSearchTerm || invoiceSearchTerm === '') {
            resetInvoiceSearchOptions();
        }
    }, [invoiceSearchTerm]);

    const resetClientSearchOptions = () => {
        setFetchNextClientPage(true);
        let newClientSearchOptions = _.cloneDeep(clientSearchDataOptions);
        newClientSearchOptions.clearFilters();
        if (typeof clientSearchTerm === 'string') {
            if (!isNaN(Number(clientSearchTerm))) {
                newClientSearchOptions?.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Contains, clientSearchTerm !== undefined ? Number(clientSearchTerm) : 0));
            } else {
                newClientSearchOptions?.addFilter(new ODataFilter('ClientName', ODataFilterOperators.Contains, clientSearchTerm !== undefined ? clientSearchTerm : ''));
            }
        }
        setClientSearchDataOptions(newClientSearchOptions);
    };

    const resetInvoiceSearchOptions = () => {
        setFetchNextInvoicePage(true);
        let newInvoiceSearchOptions = _.cloneDeep(invoiceSearchDataOptions);
        newInvoiceSearchOptions.clearFilters();
        if (typeof invoiceSearchTerm === 'string') {
            if (!isNaN(Number(invoiceSearchTerm))) {
                newInvoiceSearchOptions?.addFilter(new ODataFilter('im[INVOICE_NO]', ODataFilterOperators.Contains, invoiceSearchTerm !== undefined ? Number(invoiceSearchTerm) : 0));
            }
        }
        setInvoiceSearchDataOptions(newInvoiceSearchOptions);
    };

    const handleClientsListScrollToBottom = () => {
        incrementClients();
    };

    const handleInvoiceListScrollToBottom = () => {
        incrementInvoices();
    };

    const handleClientListSearchChanged = (inputText: string) => {
        search(inputText);
    };

    const handlePayPeriodSearchChanged = (inputText: string) => {
        payPeriodSearch(inputText);
    };

    const handleInvoiceSearchChanged = (inputText: string) => {
        invoiceSearch(inputText);
    };

    const handleInvoiceGroupSearchChanged = (inputText: string) => {
        invoiceGroupSearch(inputText);
    };

    const handleCreatedBySearchChanged = (inputText: string) => {
        createdBySearch(inputText);
    };

    const handleTotalSearchChanged = (inputText: string) => {
        totalSearch(inputText);
    };

    const handleClientListSelectChanged = (clientNumber: string) => {
        setClientSearchTerm(undefined);
        const clientNumberNumber = Number(clientNumber);
        if (!isNaN(clientNumberNumber)) {
            setSelectedClient(clientNumberNumber);
        }
    };

    const handleInvoiceListSelectChanged = (invoiceNumber: string) => {
        setInvoiceSearchTerm(undefined);
        const numericInvoiceNumber = Number(invoiceNumber);
        if (!isNaN(numericInvoiceNumber) && invoiceNumber !== null) {
            setSelectedInvoiceNumber(Number(invoices[numericInvoiceNumber].name));
        }
    };

    const handleProjectListSelectChanged = (projectNumber: number) => {
        setSelectedProject(projectNumber ? projectNumber : null);
    };

    const projectNumberToIndex = (projectNumber: number) => {
        const index = projects.findIndex(p => p.number === projectNumber);
        if (index || index === 0) {
            return index;
        } else {
            return undefined;
        }
    };

    const detectDateChange = (dateValue: string, type: 1 | 2 | 3) => {
        const currentDate = type === 1
            ? selectedBeginDate
            : type === 2
            ? selectedEndDate
            : type === 3
            ? selectedInvoiceDate
            : null;

        if (+new Date(currentDate) === +new Date(dateValue)) {
            return;
        }

        const date = new Date(dateValue);

        switch (type) {
            case 1:
                setSelectedBeginDate(date);
                break;
            case 2:
                setSelectedEndDate(date);
                break;
            case 3:
                setSelectedInvoiceDate(date);
                break;
            default:
                break;
        }
    };

    const setStateAndExecuteQuery = () => {
        const postStatus = getValues('postedOrNot');
        const voidStatus = getValues('voidOrNot');
        const sortOrder = getValues('DescOrAsc');
        const totalLike = getValues('totalLike');
        if (props?.setTotalLike) {
            props.setTotalLike(totalLike);
        }
        if (props?.setSortDirection) {
            props.setSortDirection(sortOrder === '0' ? true : false);
        }
        if (props?.setExcludePosted) {
            props.setExcludePosted(postStatus === '3');
        }
        if (props?.setExcludeUnPosted) {
            props.setExcludeUnPosted(postStatus === '2');
        }
        if (props?.setExcludeVoid) {
            props.setExcludeVoid(voidStatus === '2');
        }
        if (props?.setExcludeNonVoid) {
            props.setExcludeNonVoid(voidStatus === '3');
        }

        if (selectedBeginDate) {
            props.setSelectedBeginDate(selectedBeginDate);
        }

        if (selectedEndDate) {
            props.setSelectedEndDate(selectedEndDate);
        }

        if (props?.setSelectedOffice) {
            props.setSelectedOffice(selectedOffice);
        }
        let invoiceNumber = selectedInvoiceNumber ? ((Array.isArray(invoiceSearchResults) && invoiceSearchResults.length === 1) ?
            invoiceSearchResults[0]?.label?.replace(/[()]/g, '') : null) : null;

        if (!invoiceNumber && selectedInvoiceNumber) {
            invoiceNumber = selectedInvoiceNumber.toString();
        }
        if (props?.setInvoiceSearchTerm && !isNaN(Number(invoiceNumber))) {
            props.setInvoiceSearchTerm(invoiceNumber);
        }

        if (!!props?.runQuery) {
            props.runQuery();
        }
    };

    const clearSearchFilters = () => {
        if (selectedBeginDate) {
            setSelectedBeginDate(null);
        }

        if (selectedEndDate) {
            setSelectedBeginDate(null);
        }

        if (selectedInvoiceDate) {
            setSelectedBeginDate(null);
        }

        setValue('postedOrNot', '1');
        setValue('voidOrNot', '1');
        setValue('DescOrAsc', '0');
        setSelectedCreatedByNumber(null);
        setSelectedGroupNumber(null);
        setSelectedOffice(null);
        setSelectedTotal(null);
        setValue('createdByNumber', null);
        setValue('clientSearchResults', null);
        setValue('projectSearchResults', null);
        setValue('subcodeSearchResults', null);
        setValue('altSubcodeSearchResults', null);
        setSelectedSubcode(undefined);
        setSelectedAltSubcode(undefined);
        setValue('invoiceDate', null);
        setValue('offices', null);
        setValue('total', null);
        setValue('source', null);
        if (props?.clearSearchFilters) {
            props?.clearSearchFilters('all');
        }
    };

    const normalizePayPeriodInput = (str: string) => str.replace(/-/g, '');

    if (isLoading) {
        return (
            <div style={{ textAlign: 'center' }}>
                <h2>Loading Clients...</h2>
                <LoadingSpinner />
            </div>
        );
    } else if (!isCollapsed) {
        return (
            <Page className={'dlc-maxer-width'} style={{justifyContent: 'center'}}>
                <Page.Section width={!!props?.size ? props.size : 12}>
                    <Panel backgroundColor="#D3D3D3">
                        <Panel>
                            <form>
                                <div className="form-row" style={{ padding: '0', margin: '0'}}>
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '30%'}}>
                                        <Fieldset
                                            label={'Invoices'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Controller
                                            name="invoiceSearchResults"
                                            control={control}
                                            defaultValue={null}
                                            render={({ onChange, value }) => (
                                                <Select
                                                    id="invoiceSearchResults"
                                                    className="project-billing personnel-search-list"
                                                    placeholder={invoiceResultsPlaceholder}
                                                    options={invoiceSearchResults ? invoiceSearchResults : []}

                                                    value={
                                                        selectedInvoiceNumber
                                                        ?
                                                        { value: '1', label: selectedInvoiceNumber.toString()}
                                                        :
                                                        value
                                                        ? invoiceSearchResults.find(o => o.value === value) ?? null
                                                        : null
                                                    }

                                                    onMenuOpen={() => setIsUserSearchingInvoices(true)}
                                                    onMenuClose={() => setIsUserSearchingInvoices(false)}
                                                    onBlur={() => setIsUserSearchingInvoices(false)}
                                                    menuIsOpen={isUserSearchingInvoices}

                                                    isSearchable={true}
                                                    isClearable={true}
                                                    styles={customStyles}

                                                    onMenuScrollToBottom={handleInvoiceListScrollToBottom}
                                                    onInputChange={handleInvoiceSearchChanged}

                                                    onChange={(opt: IOptionType | null) => {
                                                        const val = opt?.value ?? null;

                                                        onChange(val);
                                                        handleInvoiceListSelectChanged(val);
                                                        if (val === null) {
                                                            setSelectedInvoiceNumber(null);
                                                            props?.clearSearchFilters('invoiceSearchResults');
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {!!props?.payPeriods && <div style={{ width: '30%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Pay Periods'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Select
                                            className="project-billing personnel-search-list"
                                            name="payPeriodsearchResults"
                                            placeholder={payPeriodResultsPlaceholder}
                                            options={payPeriodSearchResults}
                                            onChange={(e: IOptionType) => {
                                                setSelectedPayPeriod(e?.value);
                                                if (!e?.value) {
                                                    localStorage.removeItem('backOfficeSelectedPayPeriod');
                                                    setSelectedPayPeriodOption(null);
                                                    const year = new Date().getFullYear().toString();
                                                    props?.setPayPeriodSearchTerm(year);
                                                } else {
                                                    setSelectedPayPeriodOption(e);
                                                }
                                                }
                                            }
                                            value={selectedPayPeriodOption}
                                            onMenuOpen={() => setIsUserSearchingPayPeriods(true)}
                                            onMenuClose={() => setIsUserSearchingPayPeriods(false)}
                                            onBlur={() => setIsUserSearchingPayPeriods(false)}
                                            register={register}
                                            errors={errors}
                                            menuIsOpen={isUserSearchingPayPeriods}
                                            isSearchable={true}
                                            isClearable={true}
                                            filterOption={(option, inputValue) => {
                                                const normalizedLabel = normalizePayPeriodInput(option.label);
                                                const normalizedInput = normalizePayPeriodInput(inputValue);
                                                return normalizedLabel.includes(normalizedInput);
                                            }}
                                            styles={customStyles}
                                            title={`Pay Period`}
                                            onInputChange={handlePayPeriodSearchChanged}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '20%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Beginning Date'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <RHFInputBox
                                            register={register}
                                            id={'clientProjectSearchBeginDate'}
                                            name={'beginDate'}
                                            title={'Beginning Date'}
                                            defaultVal={null}
                                            type={'date'}
                                            style={{border: 'solid 1px lightgray', borderRadius: '4px', width: '100%'}}
                                            bodyStyle={{width: '100%'}}
                                            onChange={(e) => detectDateChange(e.currentTarget.value, 1)}
                                            onClick={(e) => !selectedBeginDate ? setSelectedBeginDate(new Date(e.currentTarget.value)) : {}}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '20%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Ending Date'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <RHFInputBox
                                            register={register}
                                            id={'clientProjectSearchEndDate'}
                                            name={'endDate'}
                                            title={'Ending Date'}
                                            type={'date'}
                                            defaultVal={null}
                                            style={{border: 'solid 1px lightgray', borderRadius: '4px', width: '100%'}}
                                            bodyStyle={{width: '100%'}}
                                            onChange={(e) => detectDateChange(e.currentTarget.value, 2)}
                                            onClick={(e) => !selectedEndDate ? setSelectedEndDate(new Date(e.currentTarget.value)) : {}}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '20%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Invoice Date'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <RHFInputBox
                                            register={register}
                                            id={'clientProjectInvoiceDate'}
                                            name={'invoiceDate'}
                                            title={'Invoice Date'}
                                            type={'date'}
                                            defaultVal={null}
                                            style={{border: 'solid 1px lightgray', borderRadius: '4px', width: '100%'}}
                                            bodyStyle={{width: '100%'}}
                                            onChange={(e) => detectDateChange(e.currentTarget.value, 3)}
                                            onClick={(e) => !selectedInvoiceDate ? setSelectedInvoiceDate(new Date(e.currentTarget.value)) : {}}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {!!props?.managers && <div style={{ width: '30%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Managers'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Select
                                            className="project-billing personnel-search-list"
                                            name="managerSearchResults"
                                            placeholder={managerResultsPlaceholder}
                                            options={managerSearchResults}
                                            onChange={(e: IOptionType) => props?.setSelectedManager(e.value)}
                                            onMenuOpen={() => setIsUserSearchingManagers(true)}
                                            onMenuClose={() => setIsUserSearchingManagers(false)}
                                            onBlur={() => setIsUserSearchingManagers(false)}
                                            register={register}
                                            errors={errors}
                                            menuIsOpen={isUserSearchingManagers}
                                            isSearchable={true}
                                            styles={customStyles}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {!!props?.clients && <div style={{ width: '40%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Clients'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Controller
                                            name="clientSearchResults"
                                            control={control}
                                            defaultValue={null}
                                            render={({ onChange, value }) => (
                                                <Select
                                                    id="clientSearchResults"
                                                    className="project-billing personnel-search-list"
                                                    placeholder={clientResultsPlaceholder}
                                                    options={clientSearchResults}

                                                    value={
                                                        value
                                                        ? Array.isArray(clientSearchResults) ? (clientSearchResults.find(o => o.value === value) ?? null) : null
                                                        : null
                                                    }

                                                    onMenuOpen={() => setIsUserSearchingClients(true)}
                                                    onMenuClose={() => setIsUserSearchingClients(false)}
                                                    onBlur={() => setIsUserSearchingClients(false)}
                                                    menuIsOpen={isUserSearchingClients}

                                                    isSearchable={true}
                                                    isClearable={true}
                                                    styles={customStyles}

                                                    onMenuScrollToBottom={handleClientsListScrollToBottom}
                                                    onInputChange={handleClientListSearchChanged}

                                                    onChange={(opt: IOptionType | null) => {
                                                        const val = opt?.value ?? null;

                                                        onChange(val);
                                                        handleClientListSelectChanged(val);
                                                        if (props?.clearSearchFilters && val === null) {
                                                            props?.clearSearchFilters('clientSearchResults');
                                                        }
                                                    }}
                                                />
                                            )}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {!!props?.projects && <div style={{ width: '30%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Projects'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Controller
                                            name="projectSearchResults"
                                            control={control}
                                            defaultValue={null}
                                            render={({ onChange, value }) => (
                                                <Select
                                                    className="project-billing personnel-search-list"
                                                    placeholder={projectResultsPlaceholder}
                                                    value={
                                                            value
                                                            ? projectSearchResults ? (projectSearchResults.find(o => o.value === value) ?? null) : null
                                                            : null
                                                        }
                                                    options={projectSearchResults}
                                                    onChange={(opt: IOptionType | null) => {
                                                                const val = opt?.value ?? null;

                                                                onChange(val);
                                                                handleProjectListSelectChanged(Number(val));
                                                            }}
                                                    onMenuOpen={() => setIsUserSearchingProjects(true)}
                                                    onMenuClose={() => setIsUserSearchingProjects(false)}
                                                    onBlur={() => setIsUserSearchingProjects(false)}
                                                    register={register}
                                                    errors={errors}
                                                    menuIsOpen={isUserSearchingProjects}
                                                    isSearchable={true}
                                                    isClearable={true}
                                                    styles={customStyles}
                                                />
                                            )}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {!!props?.subcodes && <div style={{ width: '30%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Subcodes'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Select
                                            isClearable={true}
                                            className="project-billing personnel-search-list"
                                            name={'subcodeSearchResults'}
                                            placeholder={subcodeSearchResultsPlaceholder}
                                            value={
                                                Array.isArray(subcodeSearchResults) ? (subcodeSearchResults.find(
                                                    x => x.value === selectedSubcode?.toString()
                                                ) ?? null) : null
                                            }
                                            options={subcodeSearchResults}
                                            formatOptionLabel={(option, { context }) =>
                                                context === 'value' || context === 'menu'
                                                    ? `${option.label} (${option.value})`
                                                    : option.label
                                            }
                                            onChange={(e: { value: string; label: string } | null) => {
                                                setSelectedSubcode(e ? Number(e.value) : null);
                                            }}
                                            onMenuOpen={() => setIsUserSearchingSubcodes(true)}
                                            onMenuClose={() => setIsUserSearchingSubcodes(false)}
                                            onBlur={() => setIsUserSearchingSubcodes(false)}
                                            register={register}
                                            errors={errors}
                                            menuIsOpen={isUserSearchingSubcodes}
                                            isSearchable={true}
                                            styles={customStyles}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {!!props?.altSubcodes && <div style={{ width: '30%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Alt Subcodes'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Select
                                            isClearable={true}
                                            className="project-billing personnel-search-list"
                                            name={'altSubcodeSearchResults'}
                                            placeholder={altSubcodeSearchResultsPlaceholder}
                                            onMenuOpen={() => setIsUserSearchingAltSubcodes(true)}
                                            onMenuClose={() => setIsUserSearchingAltSubcodes(false)}
                                            onBlur={() => setIsUserSearchingAltSubcodes(false)}
                                            value={
                                                Array.isArray(altSubcodeSearchResults) ? (altSubcodeSearchResults.find(
                                                    x => x.value === selectedAltSubcode?.toString()
                                                ) ?? null) : null
                                            }
                                            options={altSubcodeSearchResults}
                                            formatOptionLabel={(option, { context }) =>
                                                context === 'value' || context === 'menu'
                                                    ? `${option.label} (${option.value})`
                                                    : option.label
                                            }
                                            onChange={(e: { value: string; label: string } | null) => {
                                                setSelectedAltSubcode(e ? Number(e.value) : null);
                                            }}
                                            register={register}
                                            errors={errors}
                                            menuIsOpen={isUserSearchingAltSubcodes}
                                            isSearchable={true}
                                            styles={customStyles}
                                        />
                                        </Fieldset>
                                    </div>}
                                    <Button
                                        text={'Search'}
                                        className="blue-hover-button"
                                        style={{ width: '7rem', height: '3rem', verticalAlign: 'middle', marginLeft: '1rem', marginTop: '1.7rem', borderRadius: '5px' }}
                                        onClick={() => setStateAndExecuteQuery()}
                                    />
                                    <Button
                                        text="(-) Minimize"
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', marginLeft: '1rem', marginTop: '1.7rem', width: '9rem', height: '3rem', verticalAlign: 'middle', borderRadius: '5px' }}
                                        disabled={isCollapsed}
                                        onClick={() => setIsCollapsed(true)}
                                    />
                                    <Button
                                        text="Clear"
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', marginLeft: '1rem', marginTop: '1.7rem', width: '7rem', height: '3rem', verticalAlign: 'middle', borderRadius: '5px' }}
                                        onClick={() => clearSearchFilters()}
                                    />
                                </div>
                                <div className="form-row" style={{ padding: '0', margin: '0' }}>
                                    {Array.isArray(props?.offices) &&
                                        (props?.parentComponent === 'InvoiceMaintenancePageComponent' || props?.parentComponent === 'OfficeExpenses') && <div style={{ width: '10%'}}>
                                        <Fieldset
                                            label={'Offices'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Controller
                                            name="offices"
                                            control={control}
                                            defaultValue={null}
                                            render={({ onChange, value }) => (
                                                <Select
                                                    className="project-billing personnel-search-list"
                                                    placeholder={officeResultsPlaceholder}
                                                    options={officeSearchResults}

                                                    value={
                                                        value
                                                        ? { value, label: value }
                                                        : null
                                                    }

                                                    onMenuOpen={() => setIsUserSearchingOffices(true)}
                                                    onMenuClose={() => setIsUserSearchingOffices(false)}
                                                    onBlur={() => setIsUserSearchingOffices(false)}
                                                    menuIsOpen={isUserSearchingOffices}

                                                    isSearchable={true}
                                                    isClearable={true}
                                                    styles={customStyles}
                                                    title="Office"

                                                    onChange={(opt: IOptionType | null) => {
                                                        const val = opt?.label?.replace(/[()]/g, '') ?? null;

                                                        onChange(val);
                                                        setSelectedOffice(val);
                                                    }}
                                                />
                                            )}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '6%', paddingLeft: '4px'}}>
                                        <Fieldset
                                            label={'Source'}
                                            style={{width: '10rem', border: 0, padding: 0}}
                                        >
                                        <Controller
                                            name="source"
                                            control={control}
                                            defaultValue={null}
                                            render={({ onChange, value }) => (
                                                <Select
                                                    isClearable={true}
                                                    className="project-billing personnel-search-list"
                                                    placeholder={sourceResultsPlaceholder}
                                                    options={[
                                                        { value: 'M', label: 'M' },
                                                        { value: 'B', label: 'B' },
                                                        { value: 'C', label: 'C' }
                                                    ]}

                                                    value={
                                                        value
                                                        ? { value, label: value }
                                                        : null
                                                    }

                                                    onMenuOpen={() => setIsUserSearchingSources(true)}
                                                    onMenuClose={() => setIsUserSearchingSources(false)}
                                                    onBlur={() => setIsUserSearchingSources(false)}
                                                    menuIsOpen={isUserSearchingSources}

                                                    isSearchable={true}
                                                    styles={customStyles}
                                                    title="Source"

                                                    onChange={(opt) => {
                                                        const val = opt?.value ?? null;

                                                        onChange(val);                   // RHF state
                                                        props?.setSelectedSource(val);   // your filter state
                                                    }}
                                                />
                                            )}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '10%'}}>
                                        <Fieldset
                                            label={'Created By #'}
                                            style={{border: 0, padding: 0}}
                                        >
                                            <Select
                                                className="project-billing personnel-search-list"
                                                name="createdByNumber"
                                                defaultValue={null}
                                                value={
                                                    createdByList?.find(
                                                        x => x.value === selectedCreatedByNumber?.toString()
                                                    ) ?? null
                                                }
                                                isClearable={true}
                                                placeholder={createdByPlaceholder}
                                                options={createdByList ?? []}
                                                onMenuOpen={() => setIsUserSearchingCreatedBy(true)}
                                                onMenuClose={() => setIsUserSearchingCreatedBy(false)}
                                                onBlur={() => setIsUserSearchingCreatedBy(false)}
                                                register={register}
                                                errors={errors}
                                                menuIsOpen={isUserSearchingCreatedBy}
                                                isSearchable={true}
                                                styles={customStyles}
                                                title="Created By DLC#"
                                                onInputChange={handleCreatedBySearchChanged}
                                                onChange={val => {
                                                    setSelectedCreatedByNumber(val ? Number(val.value) : null);

                                                    if (!val) {
                                                        props.setSelectedCreatedByNumber(null);
                                                    }
                                                }}
                                            />
                                        </Fieldset>
                                    </div>}
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '10%'}}>
                                        <Fieldset
                                            label={'Format'}
                                            style={{border: 0, padding: 0}}
                                        >
                                        <Select
                                            isClearable={true}
                                            className="project-billing personnel-search-list"
                                            name="format"
                                            placeholder={formatsPlaceholder}
                                            options={formatTypes}
                                            onMenuOpen={() => setIsUserSearchingFormats(true)}
                                            onMenuClose={() => setIsUserSearchingFormats(false)}
                                            onBlur={() => setIsUserSearchingFormats(false)}
                                            register={register}
                                            errors={errors}
                                            menuIsOpen={isUserSearchingFormats}
                                            isSearchable={true}
                                            styles={customStyles}
                                            title={`Format`}
                                            onChange={val => {
                                                setSelectedFormatType(val?.label ? val?.label?.replace(/[()]/g, '') : null);
                                                if (!val) {
                                                    props.setSelectedFormatType(null);
                                                }
                                            }}
                                        />
                                        </Fieldset>
                                    </div>}
                                    {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <div style={{ width: '10%'}}>
                                        <Fieldset
                                            label={'Group #'}
                                            style={{border: 0, padding: 0}}
                                        >
                                            <CreatableSelect
                                                isClearable={true}
                                                className="project-billing personnel-search-list"
                                                name="invoiceGroupNumber"
                                                value={(() => {
                                                    const i = props?.invoices?.find(
                                                        x => Number(x.invoiceIrNumber) === selectedGroupNumber
                                                    );

                                                    if (i && selectedGroupNumber != null) {
                                                        return {
                                                            value: i.invoiceIrNumber.toString(),
                                                            label: i.invoiceIrNumber.toString()
                                                        };
                                                    }

                                                    if (selectedGroupNumber != null) {
                                                        return {
                                                            value: selectedGroupNumber.toString(),
                                                            label: selectedGroupNumber.toString()
                                                        };
                                                    }

                                                    if (groupNumberInputValue) {
                                                        return {
                                                            value: groupNumberInputValue,
                                                            label: groupNumberInputValue
                                                        };
                                                    }

                                                    return null;
                                                })()}
                                                placeholder={invoiceGroupPlaceholder}
                                                options={
                                                    Array.isArray(props?.invoices)
                                                        ? props.invoices.reduce((acc: { value: string; label: string }[], i) => {
                                                            if (i?.invoiceIrNumber?.trim() && !acc.find(x => x.label === i.invoiceIrNumber)) {
                                                                acc.push({ value: i.invoiceIrNumber.toString(), label: i.invoiceIrNumber });
                                                            }
                                                            return acc;
                                                        }, [])
                                                        : []
                                                }
                                                inputValue={groupNumberInputValue}
                                                onInputChange={(val) => {
                                                    setGroupNumberInputValue(val);
                                                    handleInvoiceGroupSearchChanged(val);
                                                }}
                                                onBlur={() => {
                                                    setIsUserSearchingGroupNumber(false);

                                                    if (groupNumberInputValue) {
                                                        const num = Number(groupNumberInputValue);
                                                        if (!isNaN(num)) {
                                                            setSelectedGroupNumber(num);
                                                            props.setSelectedGroupNumber(num);
                                                        }
                                                    }
                                                }}
                                                onChange={val => {
                                                    if (val) {
                                                        const num = Number(val.label);
                                                        setSelectedGroupNumber(num);
                                                        props.setSelectedGroupNumber(num);
                                                        setGroupNumberInputValue('');
                                                    } else {
                                                        setSelectedGroupNumber(null);
                                                        props.setSelectedGroupNumber(null);
                                                        setGroupNumberInputValue('');
                                                    }
                                                }}
                                                onCreateOption={(val) => {
                                                    const num = Number(val);
                                                    if (!isNaN(num)) {
                                                        setSelectedGroupNumber(num);
                                                        props.setSelectedGroupNumber(num);
                                                        setGroupNumberInputValue('');
                                                    }
                                                }}
                                                onMenuOpen={() => setIsUserSearchingGroupNumber(true)}
                                                onMenuClose={() => setIsUserSearchingGroupNumber(false)}
                                                menuIsOpen={isUserSearchingGroupNumber}
                                                isSearchable={true}
                                                styles={customStyles}
                                                title="Format"
                                            />
                                        </Fieldset>
                                    </div>}
                                    {(props?.parentComponent === 'InvoiceMaintenancePageComponent' || props?.parentComponent === 'OfficeExpenses') && <div style={{ width: '15%'}}>
                                        <Fieldset
                                            label={'Total $'}
                                            style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', width: '18rem', padding: '2px'}}
                                        >
                                            <label style={{whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '1px', margin: 0}}>
                                                Like
                                                <input
                                                    type={'checkbox'}
                                                    name={'totalLike'}
                                                    ref={register}
                                                    value={'1'}
                                                    defaultValue={'1'}
                                                    defaultChecked={false}
                                                />
                                            </label>
                                            <CreatableSelect
                                                style={{marginLeft: '2px'}}
                                                isClearable={true}
                                                className="createable-select-width project-billing personnel-search-list"
                                                name="total"
                                                value={(() => {
                                                    const i = props?.invoices?.find(
                                                        x => x.total === selectedTotal
                                                    );

                                                    if (i && selectedTotal != null) {
                                                        return {
                                                            value: i.total.toString(),
                                                            label: i.total.toString()
                                                        };
                                                    }

                                                    if (selectedTotal != null) {
                                                        return {
                                                            value: selectedTotal.toString(),
                                                            label: selectedTotal.toString()
                                                        };
                                                    }

                                                    if (totalInputValue) {
                                                        return {
                                                            value: totalInputValue,
                                                            label: totalInputValue
                                                        };
                                                    }

                                                    return null;
                                                })()}
                                                placeholder={totalPlaceholder}
                                                options={
                                                    Array.isArray(props?.invoices)
                                                    ? props.invoices.reduce((acc: { value: string; label: string }[], i) => {
                                                        if (i?.total && !acc.find(x => x.label === i.total.toString())) {
                                                            acc.push({ value: i.number.toString(), label: i.total.toString() });
                                                        }
                                                        return acc;
                                                        }, [])
                                                    : []
                                                }
                                                inputValue={totalInputValue}
                                                onInputChange={(val) => {
                                                    setTotalInputValue(val);
                                                    handleTotalSearchChanged(val);
                                                }}
                                                onBlur={() => {
                                                    setIsUserSearchingTotal(false);

                                                    if (totalInputValue) {
                                                        const num = Number(totalInputValue);
                                                        if (!isNaN(num)) {
                                                            setTotalInputValue(num.toString());
                                                            props.setSelectedTotal(num);
                                                        }
                                                    }
                                                }}
                                                onChange={val => {
                                                    if (val) {
                                                        const num = Number(val.label);
                                                        setSelectedTotal(num);
                                                        props.setSelectedTotal(num);
                                                        setTotalInputValue('');
                                                    } else {
                                                        setSelectedTotal(null);
                                                        props.setSelectedTotal(null);
                                                        setTotalInputValue('');
                                                    }
                                                }}
                                                onCreateOption={(val) => {
                                                    const num = Number(val);
                                                    if (!isNaN(num)) {
                                                        setSelectedTotal(num);
                                                        props.setSelectedTotal(num);
                                                        setTotalInputValue('');
                                                    }
                                                }}
                                                onMenuOpen={() => setIsUserSearchingTotal(true)}
                                                onMenuClose={() => setIsUserSearchingTotal(false)}
                                                menuIsOpen={isUserSearchingTotal}
                                                isSearchable={true}
                                                styles={customStyles}
                                                title="Format"
                                            />
                                        </Fieldset>
                                    </div>}
                                        {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <Fieldset
                                            label={'Posting Status'}
                                            style={{
                                                border: '1px solid black',
                                                padding: '4px 6px 6px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '16px',
                                                borderRadius: '4px',
                                                marginLeft: '4px',
                                                paddingLeft: '4px',
                                                width: '265px'
                                            }}
                                        >
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                                <input
                                                    type={'radio'}
                                                    name={'postedOrNot'}
                                                    ref={register}
                                                    value={'1'}
                                                    defaultValue={'1'}
                                                    defaultChecked={true}
                                                />
                                                All
                                            </label>

                                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                                <input
                                                    type={'radio'}
                                                    name={'postedOrNot'}
                                                    ref={register}
                                                    value="2"
                                                />
                                                Posted
                                            </label>

                                            <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                                <input
                                                    type={'radio'}
                                                    name={'postedOrNot'}
                                                    ref={register}
                                                    value={'3'}
                                                />
                                                Unposted
                                            </label>
                                        </Fieldset>}
                                        {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <Fieldset
                                            label={'Void Status'}
                                            style={{
                                                border: '1px solid black',
                                                padding: '4px 6px 6px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '16px',
                                                borderRadius: '4px',
                                                paddingLeft: '4px',
                                                width: '225px'
                                            }}
                                        >

                                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                            <input
                                                type={'radio'}
                                                name={'voidOrNot'}
                                                ref={register}
                                                value={'1'}
                                                defaultValue={'1'}
                                                defaultChecked={true}
                                            />
                                            All
                                        </label>

                                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                            <input
                                                type={'radio'}
                                                name={'voidOrNot'}
                                                ref={register}
                                                value={'2'}
                                            />
                                            Void
                                        </label>

                                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                            <input
                                                type={'radio'}
                                                name={'voidOrNot'}
                                                ref={register}
                                                value={'3'}
                                            />
                                            Active
                                        </label>
                                        </Fieldset>}
                                        {props?.parentComponent === 'InvoiceMaintenancePageComponent' && <Fieldset
                                            label={'Sort Direction'}
                                            style={{
                                                border: '1px solid black',
                                                padding: '4px 6px 6px',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '16px',
                                                borderRadius: '4px',
                                                paddingLeft: '4px',
                                                width: '245px'
                                            }}
                                        >

                                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                            <input
                                                type={'radio'}
                                                name={'DescOrAsc'}
                                                ref={register}
                                                value={'0'}
                                                defaultValue={'0'}
                                                defaultChecked={true}
                                            />
                                            Descending
                                        </label>

                                        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                                            <input
                                                type={'radio'}
                                                name={'DescOrAsc'}
                                                ref={register}
                                                value={'1'}
                                            />
                                            Ascending
                                        </label>
                                        </Fieldset>}
                                    {/*<RHFCheckbox
                                        label="Exclude Posted"
                                        style={{verticalAlign: 'middle'}}
                                        name={'filterPosted'}
                                        checked={unpostedInvoiceOption}
                                        register={register}
                                        bodyStyle={{ width: '16%', marginTop: '.5rem' }}
                                        errors={errors}
                                        onChange={() => setUnpostedInvoiceOption(!unpostedInvoiceOption)}
                                    />
                                    <RHFCheckbox
                                        label="Void only"
                                        style={{verticalAlign: 'middle'}}
                                        name={'filterVoid'}
                                        checked={voidInvoiceOption}
                                        register={register}
                                        bodyStyle={{ width: '16%', marginTop: '.5rem' }}
                                        errors={errors}
                                        onChange={() => {
                                                setVoidInvoiceOption(!voidInvoiceOption);
                                                if (!voidInvoiceOption) { setNonVoidInvoiceOption(false); }
                                            }
                                        }
                                    />
                                    <RHFCheckbox
                                        label="Not Void only"
                                        style={{verticalAlign: 'middle'}}
                                        name={'filterNonVoid'}
                                        checked={nonVoidInvoiceOption}
                                        register={register}
                                        bodyStyle={{ width: '16%', marginTop: '.5rem' }}
                                        errors={errors}
                                        onChange={() => {
                                                setNonVoidInvoiceOption(!nonVoidInvoiceOption);
                                                if (!nonVoidInvoiceOption) { setVoidInvoiceOption(false); }
                                            }
                                        }
                                    />*/}
                                </div>
                            </form>
                        </Panel>
                    </Panel>
                </Page.Section>
            </Page>
        );
    } else {
        return (
            <div style={{ textAlign: 'center' }}>
                <Button
                    text="(+) Search Filters"
                    className="blue-hover-button"
                    style={{ height: '2rem', margin: '0', padding: '.2rem' }}
                    onClick={() => setIsCollapsed(false)}
                />
            </div>
        );
    }
};

export default ClientProjectSearch;


// WEBPACK FOOTER //
// ./src/components/project-billing/components/ClientProjectSearch.tsx